import { render, staticRenderFns } from "./TabMemberDashboard.vue?vue&type=template&id=22c2dd6c"
import script from "./TabMemberDashboard.vue?vue&type=script&lang=js"
export * from "./TabMemberDashboard.vue?vue&type=script&lang=js"
import style0 from "./TabMemberDashboard.vue?vue&type=style&index=0&id=22c2dd6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports